<div class="container">
  @if (isAgreementVisible() === false) {
    <div>
      <app-agreement-not-ready [workerId]="agreement.WorkerId"></app-agreement-not-ready>
    </div>
  }

  @if (isAgreementVisible() === true) {
    <div>
      @if (agreement != null) {
        <form>
          <div fxLayout="row" fxLayoutAlign="space-between center" class="title-wrapper">
            <h1>{{ 'WorkerAgreementDetails' | translate }} - {{ agreement.FullName }}</h1>
            <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="10px">
              @if (isAgreementImported) {
                <mat-icon class="agreement-info-icon icon-lg" [matTooltip]="'WAD-IsImportedAgreementInfo' | translate"
                  >info</mat-icon
                  >
                }
                @if (isAgreementFileButtonVisible) {
                  <button mat-raised-button color="primary" (click)="onShowAgreementClick()">
                    {{ 'WAD-ShowAgreement' | translate }}
                  </button>
                }
                @if (isPIT2ButtonVisible()) {
                  <button mat-raised-button color="primary" (click)="onShowPIT2Click()">
                    {{ 'WAD-ShowPIT2' | translate }}
                  </button>
                }
                @if (isPpkCancellationStatementButtonVisible()) {
                  <button mat-raised-button color="primary" (click)="onShowPpkCancellationStatementClick()">
                    {{ 'WAD-ShowPpkCancellationStatement' | translate }}
                  </button>
                }
                <button mat-raised-button color="accent" [matMenuTriggerFor]="menu">{{ 'WAD-Actions' | translate }}</button>
                <mat-menu #menu="matMenu">
                  <button mat-menu-item (click)="onDownloadAgreementClick()" [disabled]="!isAgreementFileButtonVisible">
                    {{ 'WAD-DownloadAgreement' | translate }}
                  </button>
                  <button mat-menu-item (click)="onShowWorkerProfileClick()">{{ 'SAW-SeeWorkerProfile' | translate }}</button>
                  @if (!isPermanentAgreement() && !isAgreementRelatedToUser) {
                    <button
                      mat-menu-item
                      [disabled]="!isExtendButtonEnabled()"
                      (click)="onExtendAgreementClick()"
                      >
                      {{ 'ExtendAgreement' | translate }}
                    </button>
                  }
                  <button mat-menu-item (click)="onSendToCorrectionClick()" [disabled]="!isSendToCorrectionButtonVisible()">
                    {{ 'WAD-SendToCorrection' | translate }}
                  </button>
                  <button mat-menu-item [disabled]="!isReportIssueButtonVisible()">{{ 'WAD-ReportIssue' | translate }}</button>
                  <div [matTooltip]="!isCancelButtonEnabled() ? ('WAD-CancelAgreementTooltip' | translate) : ''">
                    <button mat-menu-item [disabled]="!isCancelButtonEnabled()" (click)="onCancelAgreementClick()">
                      {{ 'WAD-CancelAgreement' | translate }}
                    </button>
                  </div>
                  @if (isDeleteButtonVisible()) {
                  <div [matTooltip]="deleteButtonTooltip()">
                    <button mat-menu-item [disabled]="!isDeleteButtonEnabled()" (click)="onDeleteAgreementClick()">
                      {{ 'WAD-DeleteAgreement' | translate }}
                    </button>
                  </div>
                  }
                  @if (false) {
                    <button mat-menu-item (click)="onTerminationClick()" [disabled]="!isTerminationButtonEnabled">
                      {{ 'WAD-Termination' | translate }}
                    </button>
                  }
                </mat-menu>
              </div>
            </div>
            <div class="content-card">
              <h2 class="content-card__header">{{ 'WAD-Documents' | translate }}</h2>
              <table>
                <tbody>
                  <tr class="key-value-row">
                    <td class="key-value-row__key">{{ 'WAD-Agreement' | translate }}</td>
                    <td class="key-value-row__value">
                      @if (isAgreementFileButtonVisible) {
                        <a
                          class="dark-anchor"
                          href="javascript:void(0)"
                          (click)="onShowAgreementClick()"
                          download
                          >
                          {{ fileName }}
                        </a>
                      } @else {
                        <span>{{ agreementName }}</span>
                      }
                    </td>
                  </tr>
                  <tr class="key-value-row">
                    <td class="key-value-row__key">{{ 'WAD-AgreementStatus' | translate }}</td>
                    <td class="key-value-row__value">
                      @if (isLoadingIndicatorVisible) {
                        <app-custom-pacman-spinner size="xs" class="spinner">
                          <div class="spinner-label">{{ agreement.AgreementStatus }}</div>
                        </app-custom-pacman-spinner>
                      } @else {
                        {{ agreement.AgreementStatus }}
                      }
                    </td>
                  </tr>
                  @if (agreement.AgreementVoidingReason) {
                    <tr class="key-value-row">
                      <td class="key-value-row__key">{{ 'AgreementVoidingReason' | translate }}</td>
                      <td class="key-value-row__value">{{ agreement.AgreementVoidingReason }}</td>
                    </tr>
                  }
                  @if (agreement.AgreementTerminationReason) {
                    <tr class="key-value-row">
                      <td class="key-value-row__key">{{ 'AgreementTerminationReason' | translate }}</td>
                      <td class="key-value-row__value">{{ agreement.AgreementTerminationReason }}</td>
                    </tr>
                  }
                  @if (isAgreementTerminationFileButtonVisible()) {
                    <tr class="key-value-row">
                      <td class="key-value-row__key">{{ 'AgreementTerminationDocument' | translate }}</td>
                      <td class="key-value-row__value">
                        <a class="dark-anchor" href="javascript:void(0)" (click)="onShowAgreementTerminationDocumentClick()" download>{{
                          terminationFileName
                        }}</a>
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
            @if (filteredAnnexesBaseData.length > 0) {
            <div class="content-card">
              <h2 class="content-card__header">{{ 'WAD-Annexes' | translate }}</h2>
              
              <div class="annexes-list">
                @for (annex of filteredAnnexesBaseData; track annex.AnnexId) {
                  <div 
                    class="annex-row"
                    (click)="navigateToAnnex(annex.AnnexId)"
                    tabindex="0"
                    role="link">
                    {{ 'Annex.AnnexFromDate' | translate }} {{ annex.ConclusionDate | date:'yyyy-MM-dd' }} 
                    {{ 'Annex.EffectiveFrom' | translate }} {{ annex.StartDate | date:'yyyy-MM-dd' }} ({{ annex.AnnexStatus }})
                    <app-annex-imported-badge [visible]="annex.IsImported" />
                  </div>
                }
              </div>
            </div>
            }
            @if (isLegalizationFieldVisible()) {
              <div
                [visibleWithPermissions]="['LegalizationInformationVisibilityToAll', 'LegalizationInformationVisibilityToEmployerObjects']"
                class="content-card"
                >
                <h2 class="content-card__header">{{ 'Legalization.LegalizationStatus' | translate }}</h2>
                <app-legalization-status-info
                  [element]="workerAgreementLegalizationData"
                  [size]="'large'"
                  [showStatusText]="true"
                  [showTooltip]="false"
                ></app-legalization-status-info>
              </div>
            }
            <!-- Personal Data, Employer Details, and Agreement Details using shared component -->
            <app-employment-agreement-details-shared [agreement]="agreement" [annexesData]="annexesData">
            </app-employment-agreement-details-shared>
            <div class="content-card">
              <h2 class="content-card__header">{{ 'EAD-WageParameters' | translate }}</h2>
              <table>
                <tbody
                  appPropertyWithHistory
                  [label]="'WPS-WorkingTimeGroup' | translate"
                  [currentValue]="agreement.WorkingTimeGroupName"
                  [history]="workingTimeGroupHistory"
                  [showHistory]="showHistory"
                  (annexClick)="navigateToAnnex($event)"
                >
                </tbody>
                <tbody>        
                  <tr class="key-value-row">
                    <td class="key-value-row__key">{{ 'WPS-WorkingTimeSystem' | translate }}</td>
                    <td class="key-value-row__value">{{ agreement.WorkingTimeSystemName }}</td>
                  </tr>
                  <tr class="key-value-row">
                    <td class="key-value-row__key">{{ 'WPS-CalculationComponent' | translate }}</td>
                    <td class="key-value-row__value">{{ agreement.WagesCalculationComponentName }}</td>
                  </tr>
                  <tr class="key-value-row">
                    <td class="key-value-row__key">{{ 'WPS-PaymentDeadline' | translate }}</td>
                    <td class="key-value-row__value">{{ agreement.PaymentDeadlineName }}</td>
                  </tr>
                  <tr class="key-value-row">
                    <td class="key-value-row__key">{{ 'WPS-WageFrequency' | translate }}</td>
                    <td class="key-value-row__value">{{ agreement.WageFrequencyName }}</td>
                  </tr>
                  <tr class="key-value-row">
                    <td class="key-value-row__key">{{ 'WPS-WithdrawalMethod' | translate }}</td>
                    <td class="key-value-row__value">{{ agreement.WithdrawalMethodName }}</td>
                  </tr>
                  <tr class="key-value-row">
                    <td class="key-value-row__key">{{ 'WPS-CostType' | translate }}</td>
                    <td class="key-value-row__value">{{ agreement.CostTypeName }}</td>
                  </tr>
                  <tr class="key-value-row">
                    <td class="key-value-row__key">{{ 'WPS-TaxRelief' | translate }}</td>
                    <td class="key-value-row__value">{{ agreement.TaxReliefName }}</td>
                  </tr>
                  <tr class="key-value-row">
                    <td class="key-value-row__key">{{ 'WPS-LeaveBasis' | translate }}</td>
                    <td class="key-value-row__value">{{ agreement.LeaveBasis }}</td>
                  </tr>
                  @if (isTemporaryEmploymentAgreement()) {
                    <tr class="key-value-row">
                      <td class="key-value-row__key">{{ 'WPS-LeaveRule' | translate }}</td>
                      <td class="key-value-row__value">{{ agreement.LeaveRuleName }}</td>
                    </tr>
                  }
                  @if (isTemporaryEmploymentAgreement()) {
                    <tr class="key-value-row">
                      <td class="key-value-row__key">{{ 'WPS-HealthAndSafetyCondition' | translate }}</td>
                      <td class="key-value-row__value">{{ agreement.HealthAndSafetyConditionName }}</td>
                    </tr>
                  }
                  @if (isTemporaryEmploymentAgreement()) {
                    <tr class="key-value-row">
                      <td class="key-value-row__key">{{ 'WPS-EmployeeTravelBenefits' | translate }}</td>
                      <td class="key-value-row__value">{{ agreement.EmployeeTravelBenefitName }}</td>
                    </tr>
                  }
                  @if (isTemporaryEmploymentAgreement()) {
                    <tr class="key-value-row">
                      <td class="key-value-row__key">{{ 'WPS-InternalWagesRegulation' | translate }}</td>
                      <td class="key-value-row__value">{{ agreement.InternalWagesRegulationName }}</td>
                    </tr>
                  }
                  @if (isTemporaryEmploymentAgreement()) {
                    <tr class="key-value-row">
                      <td class="key-value-row__key">{{ 'WPS-WorkQualificationRequrement' | translate }}</td>
                      <td class="key-value-row__value">{{ agreement.WorkQualificationRequrementName }}</td>
                    </tr>
                  }
                  @if (isTemporaryEmploymentAgreement()) {
                    <tr class="key-value-row">
                      <td class="key-value-row__key">{{ 'WPS-TemporaryJobExpectedPeriod' | translate }}</td>
                      <td class="key-value-row__value">{{ agreement.TemporaryJobExpectedPeriodName }}</td>
                    </tr>
                  }
                  @if (isTemporaryEmploymentAgreement()) {
                    <tr class="key-value-row">
                      <td class="key-value-row__key">{{ 'WPS-HolidayLeaveLimit' | translate }}</td>
                      <td class="key-value-row__value">{{ agreement.HolidayLeaveLimitName }}</td>
                    </tr>
                  }
                  @if (isTemporaryEmploymentAgreement()) {
                    <tr class="key-value-row">
                      <td class="key-value-row__key">{{ 'WPS-AbsenceConfirmationType' | translate }}</td>
                      <td class="key-value-row__value">{{ agreement.WorkAbsenceConfirmationTypeName }}</td>
                    </tr>
                  }
                  @if (isTemporaryEmploymentAgreement()) {
                    <tr class="key-value-row">
                      <td class="key-value-row__key">{{ 'WPS-PresenceConfirmationType' | translate }}</td>
                      <td class="key-value-row__value">{{ agreement.WorkPresenceConfirmationTypeName }}</td>
                    </tr>
                  }
                  @if (isTemporaryEmploymentAgreement()) {
                    <tr class="key-value-row">
                      <td class="key-value-row__key">{{ 'WPS-TimeForJustifingAbsence' | translate }}</td>
                      <td class="key-value-row__value">{{ agreement.TimeForJustifingAbsence }}</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
            <div class="content-card">
              <h2 class="content-card__header">{{ 'EAD-Insurance' | translate }}</h2>
              <table>
                <tbody>
                  @for (insurance of agreement?.EmploymentAgreementInsurances; track insurance; let i = $index) {
                    <div class="key-value-row">
                      <tr class="key-value-row">
                        <td class="key-value-row__key">{{ 'InsuranceStartDate' | translate }}</td>
                        <td class="key-value-row__value">{{ insurance.InsuranceStartDate | date : 'yyyy-MM-dd' }}</td>
                      </tr>
                      <tr class="key-value-row">
                        <td class="key-value-row__key">{{ 'InsuranceEndDate' | translate }}</td>
                        <td class="key-value-row__value">{{ insurance.InsuranceEndDate | date : 'yyyy-MM-dd' }}</td>
                      </tr>
                      <tr class="key-value-row">
                        <td class="key-value-row__key">{{ 'InsuranceTitleCode' | translate }}</td>
                        <td class="key-value-row__value">{{ insurance.InsuranceTitleCode }}</td>
                      </tr>
                    </div>
                  }
                </tbody>
              </table>
            </div>
            @if ((listOfConsentTypes$ | async)?.length > 0) {
              <div class="content-card">
                @for (consentType of listOfConsentTypes$ | async; track consentType) {
                  <form fxLayout="column" fxLayoutGap="10px" [formGroup]="consentsFormGroup">
                    <!-- Consent -->
                    @if (consentsFormGroup.controls['consent_' + consentType.Id]) {
                      <div class="checkbox-value" fxLayout="row" fxLayoutGap="10px">
                        <mat-checkbox [formControlName]="'consent_' + consentType.Id" (change)="toggleConsent($event, consentType.Id)" #cc></mat-checkbox>
                        <label [class.required-consent]="!cc.checked && consentType.IsRequired">
                          @if (isConsentExpanded(consentType.Id)) {
                            <span>{{ consentType.Name | translate }}</span>
                          }
                          @if (!isConsentExpanded(consentType.Id)) {
                            <span>{{ consentType.Name | translate | slice : 0 : 100 }}</span>
                          }
                        </label>
                        <div class="toggler" (click)="toggleLabel(consentType.Id)">
                          @if (isConsentExpanded(consentType.Id)) {
                            <mat-icon class="icon">expand_less</mat-icon>
                          }
                          @if (!isConsentExpanded(consentType.Id)) {
                            <mat-icon class="icon">expand_more</mat-icon>
                          }
                        </div>
                      </div>
                    }
                  </form>
                }
                <!-- RODO -->
                @if (rodoClause$ | async; as clause) {
                  <div>
                    <a [href]="clause.File" target="_blank" rel="noopener noreferrer">{{ clause.Name }}</a>
                  </div>
                }
                @for (item of clauses$ | async; track item) {
                  <div>
                    <a [href]="item.File" target="_blank" rel="noopener noreferrer">{{ item.Name }}</a>
                  </div>
                }
              </div>
            }
            <!-- Digital Signature Approval Section -->
            @if (isSignaturePadVisible()) {
              <div class="content-card">
                @if (isAgreementRelatedToUser) {
                  <h2 class="content-card__header">
                    @if (isAgreementSignedByEmployerRepresentative | async) {
                      @if (agreement.ShouldHavePIT2 && agreement.ShouldHavePpkCancellation) {
                        {{ 'WAD-PpkAndPIT2AndAgreementEmployeeSignatureApproval' | translate }}
                      } @else if (agreement.ShouldHavePIT2){
                        {{ 'WAD-PIT2AndAgreementEmployeeSignatureApproval' | translate }}
                      } @else if (agreement.ShouldHavePpkCancellation){
                        {{ 'WAD-PpkAgreementEmployeeSignatureApproval' | translate }}
                      } @else {
                        {{ 'WAD-EmployeeSignatureApproval' | translate }}
                      }
                    } @else {
                      {{ 'WAD-EmployerRepresentativeSignatureApproval' | translate }}
                    }
                  </h2>
                  <app-signature-pad></app-signature-pad>
                  <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="10px" class="buttons-wrapper">
                    <button mat-raised-button color="accent" (click)="onClearSignaturePadClick()" [disabled]="isSignaturePadEmpty">
                      {{ 'Clear' | translate }}
                    </button>
                    <button mat-raised-button color="primary" (click)="onSignAgreementClick()" [disabled]="!isSignatureValid">
                      {{ 'WAD-SignAgreement' | translate }}
                    </button>
                  </div>
                } @else {
                  @if (hasSignAgreementAsEmployerRepresentativePermission) {
                    <h2 class="content-card__header">
                      @if (isAgreementSignedByEmployerRepresentative | async) {
                        @if (agreement.ShouldHavePIT2 && agreement.ShouldHavePpkCancellation) {
                          {{ 'WAD-PpkAndPIT2AndAgreementEmployeeSignatureApproval' | translate }}
                        } @else if (agreement.ShouldHavePIT2){
                          {{ 'WAD-PIT2AndAgreementEmployeeSignatureApproval' | translate }}
                        } @else if (agreement.ShouldHavePpkCancellation){
                          {{ 'WAD-PpkAgreementEmployeeSignatureApproval' | translate }}
                        } @else {
                          {{ 'WAD-EmployeeSignatureApproval' | translate }}
                        }
                      } @else {
                        {{ 'WAD-EmployerRepresentativeSignatureApproval' | translate }}
                      }
                    </h2>
                    @if (isAgreementSignedByEmployerRepresentative | async) {
                      <mat-checkbox (change)="employeeSignatureEnabled = $event.checked">
                        {{ 'WAD-EnableSignatureApproval' | translate }}
                      </mat-checkbox>
                      @if (employeeSignatureEnabled) {
                        <app-signature-pad></app-signature-pad>
                        <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="10px" class="buttons-wrapper">
                          <button mat-raised-button color="accent" (click)="onClearSignaturePadClick()" [disabled]="isSignaturePadEmpty">
                            {{ 'Clear' | translate }}
                          </button>
                          <button mat-raised-button color="primary" (click)="onSignAgreementClick()" [disabled]="!isSignatureValid">
                            {{ 'WAD-SignAgreement' | translate }}
                          </button>
                        </div>
                      }
                    } @else {
                      <app-signature-pad></app-signature-pad>
                      <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="10px" class="buttons-wrapper">
                        <button mat-raised-button color="accent" (click)="onClearSignaturePadClick()" [disabled]="isSignaturePadEmpty">
                          {{ 'Clear' | translate }}
                        </button>
                        <button mat-raised-button color="primary" (click)="onSignAgreementClick()" [disabled]="!isSignatureValid">
                          {{ 'WAD-SignAgreement' | translate }}
                        </button>
                      </div>
                    }
                  } @else {
                    @if (!agreement.IsSendToVerification) {
                      <div>
                        {{ 'WAD-SendEmploymentAgreementToVerificationInfo' | translate }}
                      </div>
                    } @else {
                      <div>{{ 'WAD-AgreementInVerificationInfo' | translate }}</div>
                    }
                  }
                }
              </div>
            }
            <div class="row">
              <div class="col-md-6">
                @if (isLegalizationFieldForGeneratedVisible()) {
                  <div
                    [visibleWithPermissions]="['LegalizationInformationVisibilityToAll', 'LegalizationInformationVisibilityToEmployerObjects']"
                    >
                    <app-legalization-status-info
                      [element]="workerAgreementLegalizationData"
                      [size]="'large'"
                      [showStatusText]="true"
                      [showTooltip]="false"
                      [showLabel]="true"
                    ></app-legalization-status-info>
                  </div>
                }
              </div>
              <div class="col-md-6">
                @if (isSendToVerificationButtonVisible()) {
                  <button
                    mat-raised-button
                    color="primary"
                    class="float-right"
                    (click)="onSendToVerificationApprovalClick()"
                    [disabled]="agreement.IsSendToVerification"
                    >
                    {{ 'WAD-SendToVerification' | translate }}
                  </button>
                }
                @if (isSendToCorrectionButtonVisible()) {
                  <button mat-raised-button color="primary" class="float-right" (click)="onSendToCorrectionClick()">
                    {{ 'WAD-SendToCorrection' | translate }}
                  </button>
                }
                @if (isSendToApprovalButtonVisible()) {
                  <button
                    mat-raised-button
                    color="primary"
                    class="float-right"
                    (click)="onSendToWorkerApprovalClick()"
                    >
                    {{ 'WAD-SendToWorkerApproval' | translate }}
                  </button>
                }
              </div>
            </div>
          </form>
        }
      </div>
    }
  </div>


